import { useAtom } from 'jotai'
import { useLocalStorage } from 'usehooks-ts'
import { maskedAssetsAtom, maskedAssetsStorageKey } from './atoms'
import { useEffect } from 'react'

export function useMaskedAssets() {
  const [localMaskedAssets, setLocalMaskedAssets] = useLocalStorage<boolean>(
    maskedAssetsStorageKey,
    false,
  )
  const atom = useAtom(maskedAssetsAtom)

  const [maskedAssets] = atom

  useEffect(() => {
    maskedAssets !== localMaskedAssets && setLocalMaskedAssets(maskedAssets)
  }, [maskedAssets, localMaskedAssets, setLocalMaskedAssets])

  return atom
}
